var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 128V0H48C21.49 0 0 21.492 0 48V464C0 490.508 21.49 512 48 512H336C362.51 512 384 490.508 384 464V160H256C238.326 160 224 145.672 224 128ZM281.5 211.125C285.625 214.125 288 218.875 288 224V384C288 401.625 266.5 416 240 416S192 401.625 192 384S213.5 352 240 352C245.375 352 250.75 352.75 256 354.001V277.625L160 315.125V416C160 433.625 138.5 448 112 448S64 433.625 64 416S85.5 384 112 384C117.375 384 122.75 384.75 128 386.001V271.25C128 264.25 132.5 258.125 139.25 256L267.25 208.75C272 207.25 277.375 208.125 281.5 211.125ZM256 0V128H384L256 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMusic);
export default __webpack_public_path__ + "static/media/file-music.3c1e48ec72e83ef98c761bffb3f3b382.svg";
export { ForwardRef as ReactComponent };